module.exports = __webpack_public_path__ + "img/warning.58755713.svg";